export function onReady(callback: () => void): void {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
    return;
  }

  callback();
}

export function queryAll<T extends Element>(
  selector: string,
  root: ParentNode = document
): T[] {
  return Array.from(root.querySelectorAll<T>(selector));
}

export function queryInclusive<T extends Element>(
  selector: string,
  root: ParentNode = document
): T[] {
  const matches: T[] = [];

  if (root instanceof Element && root.matches(selector)) {
    matches.push(root as T);
  }

  matches.push(...queryAll<T>(selector, root));

  return matches;
}

export function claimElements<T extends Element>(
  selector: string,
  claimAttribute: string,
  root: ParentNode = document
): T[] {
  return queryInclusive<T>(selector, root).filter((element) => {
    if (element.hasAttribute(claimAttribute)) {
      return false;
    }

    element.setAttribute(claimAttribute, 'true');
    return true;
  });
}
